import React, { createContext, Dispatch } from 'react';
import { Action } from './reducer';
import { AppState } from './interfaces';

const AppStateContext: React.Context<{
	dispatch: Dispatch<Action>;
	state: AppState;
}> = createContext({} as { dispatch: Dispatch<Action>; state: AppState });
export default AppStateContext;
